export enum DataIdLivingConditionsPage {
  INPUT_BIRTHDATE = 'LivingConditionsPage-Input-Birthdate',
  INPUT_EMPLOYMENT = 'LivingConditionsPage-Input-Employment',
  INPUT_PROFESSION = 'LivingConditionsPage-Input-Profession',
  INPUT_SMOKER = 'LivingConditionsPage-Input-Smoker',
  INPUT_HEIGHT = 'LivingConditionsPage-Input-Height',
  INPUT_WEIGHT = 'LivingConditionsPage-Input-Weight',
  INPUT_BIKER_YES = 'LivingConditionsPage-Input-Biker-Yes',
  INPUT_BIKER_NO = 'LivingConditionsPage-Input-Biker-No',
  INPUT_PROPERTY_OWNER_YES = 'LivingConditionsPage-Input-Property-Owner-Yes',
  INPUT_PROPERTY_OWNER_NO = 'LivingConditionsPage-Input-Property-Owner-No',
  INPUT_INCEPTION_DATE = 'LivingConditionsPage-Input-Inception-Date',
}

export enum DataIdFooter {
  BUTTON_BACKBUTTON = 'Footer-BackButton',
  BUTTON_NEXTBUTTON = 'Footer-NextButton',
}

export enum DataIdFeePage {
  INPUT_PAYMENT_INTERVAL = 'FeePage-Input-Payment-Interval',
  COMPARISON_TABLE = 'FeePage-ComparisonTable',
  PRICE_VARIANT = 'FeePage-Price-Variant-',
  PRICE_VARIANT_KOMFORT = 'FeePage-Price-Variant-Komfort',
  PRICE_VARIANT_PREMIUM = 'FeePage-Price-Variant-Premium',
  INPUT_RADIO_VARIANT = 'FeePage-Input-Radio-Variant-',
  INPUT_CHECKBOX = 'FeePage-Input-Checkbox-',
}
